import TodayResult from "./TodayResult";
import { displayClose } from "src/pods/realtime";
import { useToolkitTodayStore } from "src/pods/today/toolkitTodayStore";
import PresentationPage from "src/shared/components/PresentationPage";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

export default function TodayResultContainer() {
  const notes = useToolkitTodayStore();

  return (
    <PresentationPage variant="today" onRequestHide={() => dispatchToolkitReduxAction(displayClose())}>
      <TodayResult text={notes.text} title={notes.title} />
    </PresentationPage>
  );
}
